import { ng } from '@uirouter/angularjs/lib/angular';
import { StateParams, StateService } from '@uirouter/core';
import * as angular from 'angular';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { AccountService } from '../../account.service';
import { JispPayAccountService } from '../../jispPayAccount.service';
import { ILogIn } from '../../model';

export class LoginController {
    public static $inject = ['$state', 'accountService', 'jispPayAccountService', '$timeout', 'notificationService', '$translate', '$q', '$stateParams'];
    public email: string = null;
    public password: string = null;
    public waiting: boolean = false;
    public submitted: boolean = false;
    public loginForm: ng.IFormController;
    public showPassword: false;
    public sellerLogged: boolean = true;
    public retailerLogged: boolean = true;
    public loginError: any;
    private isAccountBlocked: boolean = false;

    constructor(
        private $state: StateService,
        private accountService: AccountService,
        private jispPayAccountService: JispPayAccountService,
        private $timeout: ng.ITimeoutService,
        private notificationService: NotificationService,
        private $translate: angular.translate.ITranslateService,
        public $q: ng.IQService,
        private $stateParams: StateParams
    ) { }

    public async submit() {
        this.submitted = true;

        this.checkForAutoFilledValues();

        if (this.loginForm.$invalid) {
            return;
        }

        this.waiting = true;
        this.notificationService.showWaitingMessage();

        this.sellerLogged = true;
        this.retailerLogged = true;

        const p1 = Promise.resolve(await this.loginRetailer());
        const p2 = Promise.resolve(await this.loginSeller());
        Promise.all([p1, p2])
            .catch((err) => console.log('Catch', err))
            .then(() => {
                if (this.retailerLogged) {
                    this.jispPayAccountService.reset();
                    this.$timeout(() => {
/*                         if (this.$stateParams.url) {
                            window.open(this.$stateParams.url, '_self');
                        } else {
                            this.$state.go('home.screen');
                        } */
                        this.$state.go('home.screen');
                    }, 1500);
                    return;
                }
                if (this.sellerLogged) {
/*                     if (this.$stateParams.url) {
                        window.open(this.$stateParams.url, '_self');
                    } else {
                        this.jispPayAccountService.navigateToDefault();
                    } */
                    const referer = document.referrer;
                    if (referer && referer.match('/jisppay/deliveryDetails')) {
                        location.href = document.referrer;
                    } else {
                        this.jispPayAccountService.navigateToDefault();
                    }
                    return;
                }
                if (!this.retailerLogged && !this.sellerLogged) {
                    angular.element('input[name="email"]').removeClass('ng-valid');
                    angular.element('input[name="email"]').addClass('ng-invalid');
                    angular.element('input[name="password"]').removeClass('ng-valid');
                    angular.element('input[name="password"]').addClass('ng-invalid');
                    this.$timeout(() => {
                        angular.element('input[name="email"]').removeClass('ng-invalid');
                        angular.element('input[name="password"]').removeClass('ng-invalid');
                    }, 3000);

                    this.notificationService.showErrorMessage(this.loginError);
                    this.waiting = false;
                }
        });
    }

    public async loginRetailer() {
        try {
            const model: ILogIn = { adminLogin: false, userName: this.email, password: this.password };
            const response = await this.accountService.logIn(model);
            if (response == null) {
                this.retailerLogged = false;
                return false;
            }
            this.showSuccessLoggedInMessage();
            await this.accountService.fillAuthData();
            return true;
        } catch (error) {
            this.loginError = error;
            this.retailerLogged = false;
            this.isAccountBlocked = false;
            if (error.error === 'account_blocked') {
                this.isAccountBlocked = true;
                this.loginError = error.error_description;
            }
            return false;
        }
    }

    public async loginSeller() {
        try {
            const response = await this.jispPayAccountService.logIn({
                email: this.email,
                password: this.password
            });

            if (response == null) {
                this.sellerLogged = false;
                return false;
            }

            const stores = await this.jispPayAccountService.getStores();
            switch (stores.length) {
                case 0:
                    this.jispPayAccountService.reset();
                    throw this.$translate.instant('no_permissions_to_any_store');
                case 1:
                    await this.jispPayAccountService.storeLogIn(stores[0].ID);
                    this.showSuccessLoggedInMessage();
                    await this.$timeout(1500);
                    break;
                default:
                    this.notificationService.clearAll();
                    break;
            }
            return true;
        } catch (error) {
            if (!this.isAccountBlocked) {
                this.loginError = error;
            }
            this.sellerLogged = false;
            this.isAccountBlocked = false;
            return false;
        }
    }

    public checkForAutoFilledValues() {
        const inputEmail: string = (document.getElementsByName('email')[0] as any).value;
        const inputPassword: string = (document.getElementsByName('password')[0] as any).value;
        if (this.loginForm.$pristine && inputEmail && inputEmail.length > 0 && inputPassword && inputPassword.length > 0) {
            this.setAutoFilledValues(this.loginForm);
        }
    }

    public setAutoFilledValues(form: angular.IFormController) {
        angular.forEach(form, (control: angular.INgModelController, name: string) => {
            if (typeof name === 'string' && name.charAt(0) !== '$') {
                const value: string = (document.getElementsByName(name)[0] as any).value;
                control.$setViewValue(value);
                control.$validate();
            }
        });
    }

    private showSuccessLoggedInMessage() {
        this.notificationService.showSuccessMessage({
            title: this.$translate.instant('welcome'),
            body: this.$translate.instant('welcome_logged_in'),
            timeout: 3000
        });
    }
}
angular.module('naut')
    .component('login', {
        template: require('./login.html'),
        controller: LoginController,
        controllerAs: 'ctrl'
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/account/components/login/login.component.ts